import React, { useState } from 'react'
 
 
import TaxList from './TaxList';
import TaxForm from './TaxForm';

const Tax= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <TaxForm addForm={setFromIsShown} update={upData}  sId={serviceId} />
        ) : (
          <TaxList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}
  
    </>
  )
}

export default Tax